export default __webpack_public_path__ + "static/polygon-43cccf05e642cb817ebedab82047e8c3.svg";